import { post } from '../index';

export const requestResetPassword = data => {
  return post('/users/user/request-reset-password', data);
};
